import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './PreventivoLavoriCase.scss';
import useSimpleCaseData from "../../../../hooks/useSimpleCaseData";

const PreventivoLavoriCase = () => {
  const {data, blockCaseIfNoContract} = useSimpleCaseData();
  return (
    <div className="PreventivoLavoriCase" data-testid="PreventivoLavoriCase">
      <CaseGenerator
        type={CaseForms.PreventivoLavori}
        initialValues={data}
        blockIfNoContracts={blockCaseIfNoContract}
      />
    </div>
  );
};


export default PreventivoLavoriCase;
